// Video Testimonials #2 - Video Control System
function tptVideoTestimonials2PauseAllVideos() {
	document.querySelectorAll('.video-testimonials-2_video video').forEach((video) => video.pause());
}

function tptVideoTestimonials2MuteAllVideos() {
	document.querySelectorAll('.video-testimonials-2_video video').forEach((video) => (video.muted = true));
}

if (!customElements.get('tpt-video-testimonials-2-item')) {
	customElements.define(
		'tpt-video-testimonials-2-item',
		class TptVideoTestimonials2Item extends HTMLElement {
			constructor() {
				super();

				this.playPauseBtn = this.querySelector('.video-testimonials-2_play-pause-btn');
				this.video = this.querySelector('.video-testimonials-2_video video');
				this.videoWrapper = this.querySelector('.video-testimonials-2_video-wrapper');
				this.playIcon = this.querySelector('.play-icon');
				this.pauseIcon = this.querySelector('.pause-icon');

				this.init();
			}

			init() {
				if (this.playPauseBtn) {
					this.playPauseBtn.addEventListener('click', this.togglePlayPause.bind(this));
					
					// Make button accessible
					this.playPauseBtn.setAttribute('tabindex', '0');
					this.playPauseBtn.setAttribute('role', 'button');
					this.playPauseBtn.setAttribute('aria-label', 'Play video');
					
					// Handle keyboard events
					this.playPauseBtn.addEventListener('keydown', (e) => {
						if (e.key === 'Enter' || e.key === ' ') {
							e.preventDefault();
							this.togglePlayPause();
						}
					});
				}

				// Add click event to video wrapper for play/pause toggle
				if (this.videoWrapper) {
					this.videoWrapper.addEventListener('click', (e) => {
						// Check if click is on the play/pause button
						if (e.target.closest('.video-testimonials-2_play-pause-btn')) {
							return; // Let the button handle the click
						}
						
						// Toggle play/pause when clicking on video area
						this.togglePlayPause();
					});
				}

				this.setupVideoEvents();
				this.updateButtonState();
			}

			togglePlayPause() {
				if (!this.video) return;

				if (this.video.paused) {
					this.playVideo();
				} else {
					this.pauseVideo();
				}
			}

			playVideo() {
				if (!this.video) return;

				// If video is already playing, pause it
				if (!this.video.paused) {
					this.pauseVideo();
					return;
				}

				tptVideoTestimonials2MuteAllVideos();

				/**
				 * Pause all videos if only one video mode is enabled
				 */
				const container = this.closest('tpt-video-testimonials-2-container');
				if (container && container.dataset.onlyOneVideo === 'true') {
					tptVideoTestimonials2PauseAllVideos();
					
					// Reset all video items to paused state
					document.querySelectorAll('tpt-video-testimonials-2-item').forEach((item) => {
						item.classList.remove('playing');
						const itemVideo = item.querySelector('.video-testimonials-2_video video');
						if (itemVideo) {
							itemVideo.classList.remove('active');
						}
					});
				}

				/**
				 * Activate current video
				 */
				this.classList.add('playing');
				this.video.classList.add('active');
				this.video.muted = false;
				this.video.play();

				this.updateButtonState();

				/**
				 * Handle other sections when not in one-video mode
				 */
				if (!container || container.dataset.onlyOneVideo !== 'true') {
					const oneVideoContainers = document.querySelectorAll('tpt-video-testimonials-2-container[data-only-one-video="true"]');

					oneVideoContainers.forEach((oneVideoContainer) => {
						const itemVideos = oneVideoContainer.querySelectorAll('tpt-video-testimonials-2-item');

						itemVideos.forEach((item) => {
							const videos = item.querySelectorAll('.video-testimonials-2_video video');

							if (videos.length >= 1) {
								videos[0].play();
								videos[0].muted = true;
							}
						});
					});
				}
			}

			pauseVideo() {
				if (!this.video) return;

				this.video.classList.remove('active');
				this.video.pause();
				this.video.muted = true;
				this.classList.remove('playing');

				this.updateButtonState();
			}

			updateButtonState() {
				if (!this.playPauseBtn || !this.video) return;

				const isPlaying = !this.video.paused && !this.video.muted;

				if (this.playIcon && this.pauseIcon) {
					if (isPlaying) {
						this.playIcon.style.display = 'none';
						this.pauseIcon.style.display = 'block';
						this.playPauseBtn.setAttribute('aria-label', 'Pause video');
					} else {
						this.playIcon.style.display = 'block';
						this.pauseIcon.style.display = 'none';
						this.playPauseBtn.setAttribute('aria-label', 'Play video');
					}
				}
			}

			setupVideoEvents() {
				if (!this.video) return;

				// Handle video errors
				this.video.addEventListener('error', (e) => {
					console.warn('Video testimonial failed to load:', e);
					this.style.opacity = '0.5';
				});

				// Prevent default video controls
				this.video.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopPropagation();
				});

				// Disable context menu
				this.video.addEventListener('contextmenu', (e) => {
					e.preventDefault();
				});

				// Handle video ended
				this.video.addEventListener('ended', () => {
					this.classList.remove('playing');
					this.video.classList.remove('active');
					this.video.currentTime = 0;
					this.updateButtonState();
				});

				// Handle video loading
				this.video.addEventListener('loadeddata', () => {
					this.style.opacity = '1';
				});

				// Handle video pause
				this.video.addEventListener('pause', () => {
					if (this.classList.contains('playing')) {
						this.classList.remove('playing');
						this.video.classList.remove('active');
						this.updateButtonState();
					}
				});

				// Handle video play
				this.video.addEventListener('play', () => {
					if (!this.classList.contains('playing')) {
						this.classList.add('playing');
						this.video.classList.add('active');
						this.updateButtonState();
					}
				});

				// Handle video time update for accessibility
				this.video.addEventListener('timeupdate', () => {
					if (this.video.duration > 0) {
						const progress = (this.video.currentTime / this.video.duration) * 100;
						this.video.setAttribute('aria-valuenow', Math.round(progress));
					}
				});
			}
		}
	);
}

if (!customElements.get('tpt-video-testimonials-2-container')) {
	customElements.define(
		'tpt-video-testimonials-2-container',
		class TptVideoTestimonials2Container extends HTMLElement {
			constructor() {
				super();
			}

			connectedCallback() {
				this.initializeVideos();
			}

			initializeVideos() {
				const videoItems = this.querySelectorAll('tpt-video-testimonials-2-item');
				
				videoItems.forEach((item) => {
					const video = item.querySelector('.video-testimonials-2_video video');
					if (video) {
						this.setupVideoAttributes(video);
					}
				});
			}

			setupVideoAttributes(video) {
				// Set up accessibility attributes
				video.setAttribute('role', 'img');
				video.setAttribute('aria-label', 'Customer video testimonial');
				video.setAttribute('aria-valuenow', '0');
				video.setAttribute('aria-valuemin', '0');
				video.setAttribute('aria-valuemax', '100');

				// Ensure video properties
				video.muted = true;
				video.playsInline = true;
				video.preload = 'metadata';

				// Remove default controls
				video.removeAttribute('controls');
			}
		}
	);
}

// Global utility functions
window.tptVideoTestimonials2PauseAllVideos = tptVideoTestimonials2PauseAllVideos;
window.tptVideoTestimonials2MuteAllVideos = tptVideoTestimonials2MuteAllVideos;

// Handle page visibility changes
document.addEventListener('visibilitychange', () => {
	if (document.hidden) {
		// Pause all videos when page becomes hidden
		tptVideoTestimonials2PauseAllVideos();
	}
});

// Handle intersection observer for performance
const videoObserver = new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		const videoItem = entry.target;
		const video = videoItem.querySelector('.video-testimonials-2_video video');
		
		if (video) {
			if (entry.isIntersecting) {
				// Video is in viewport
				video.preload = 'metadata';
			} else {
				// Video is out of viewport - pause if playing
				if (!video.paused) {
					video.pause();
				}
			}
		}
	});
}, {
	rootMargin: '50px',
	threshold: 0.1
});

// Observe video items when they're added to the DOM
const observeVideoItems = () => {
	document.querySelectorAll('tpt-video-testimonials-2-item').forEach((item) => {
		videoObserver.observe(item);
	});
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', observeVideoItems);
} else {
	observeVideoItems();
}

// Handle Shopify theme editor
if (window.Shopify && window.Shopify.designMode) {
	document.addEventListener('shopify:section:load', () => {
		// Re-initialize custom elements when sections are loaded in theme editor
		setTimeout(() => {
			const containers = document.querySelectorAll('tpt-video-testimonials-2-container');
			containers.forEach(container => {
				if (container.initializeVideos) {
					container.initializeVideos();
				}
			});
			observeVideoItems();
		}, 100);
	});

	document.addEventListener('shopify:section:unload', () => {
		// Pause all videos when section is unloaded
		tptVideoTestimonials2PauseAllVideos();
	});

	document.addEventListener('shopify:section:select', () => {
		// Pause all videos when another section is selected
		tptVideoTestimonials2PauseAllVideos();
	});
}